<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    :close-on-click-modal="true"
    :append-to-body="true"
    :show-close="false"
    :custom-class="'all-notes__dialog'"
  >
    <div class="all-notes">
      <div class="all-notes__title">My notes</div>
      <div
        v-for="(note, index) in filteredList"
        :key="index"
        class="all-notes__item"
        :class="{ fixed: note.fixed }"
      >
        <Note
          :date="note.created"
          :text="note.body__value"
          :fixed="note.fixed"
          :note-id="note.id"
          @startEvent="loading = true"
          @finishEvent="loading = false"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "AllNotes",
  components: {
    Note: () => import("../../components/profile/Note"),
  },
  props: {
    notesList: {
      type: Array,
      default: null,
    },
    visibleSection: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState("Dialog", [
      "contentDialog",
      "dialogTitle",
      "noteFor",
      "allDialogOpen",
    ]),
    visible: {
      get() {
        let vis = false;
        if (
          this.allDialogOpen &&
          this.noteFor &&
          this.noteFor.section === this.visibleSection
        )
          vis = true;
        return vis;
      },
      set(value) {
        this.$store.commit("Dialog/setData", { label: "noteFor", data: {} });
        this.$store.commit("Dialog/setData", {
          label: "allDialogOpen",
          data: false,
        });
      },
    },
    filteredList() {
      let arr = [];
      if (this.notesList) {
        arr = JSON.parse(JSON.stringify(this.notesList));
        arr.sort(function (a, b) {
          if (a.fixed > b.fixed) {
            return -1;
          }
          if (a.fixed < b.fixed) {
            return 1;
          }
          return 0;
        });
      }
      return arr;
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.all-notes {
  border-top: 1px dashed $border;
  border-left: 1px dashed $border;
  margin-top: -30px;
  margin-right: -20px;
  &__dialog {
    width: 45rem;
    max-width: 90%;
  }
  &__title {
    font-size: 1.8rem;
    font-weight: 700;
    margin-bottom: 2rem;
    margin-left: 2rem;
    color: $black;
  }
  &__item {
    display: flex;
    align-items: flex-start;
    position: relative;
    padding: 2rem 0 2rem 3rem;
    &:after {
      position: absolute;
      content: "";
      width: 1.6rem;
      height: 1.6rem;
      border: 2px solid $black;
      background: #8dc8e8;
      border-radius: 50%;
      left: 2rem;
      top: 2rem;
    }
    &:before {
      position: absolute;
      content: "";
      width: 2rem;
      height: 1px;
      border-bottom: 1px dashed $border;
      left: 0;
      top: 2.8rem;
    }
    &.fixed {
      background: $light_yellow2;
      &:after {
        background: $light_yellow;
      }
    }
  }
}
</style>
